import { Button, Grid, styled, TextField, Theme } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
import { createStyles, makeStyles } from '@material-ui/core';
const {
  DARK_FIELDS_FLOATING_BUTTON_BACKGROUND,
  DARK_CONTAINER_FIELDS_ON_CARD,
  LIGHT_CONTAINER_FIELDS_ON_CARD,
  DARK_CONTAINER_FIELDS_FLOATING,
  LIGHT_CONTAINER_FIELDS_FLOATING,
  PLAIN_TEXT,
  DARK_TEXT,
  WARNING_TEXT,
  PRIMARY_TEXT,
  PRIMARY_BUTTON_BACKGROUND,
  DARK_FIELDS_ON_CARD_MENU,
  LIGHT_MENUITEM_BACKGROUND,
  PLAIN_ICON,
  DARK_ICON,
  DARK_BUTTON_BORDER,
  LIGHT_BUTTON_BORDER,
} = COLORS;

export const ProfileMainCont = styled(Grid)(({ theme }) => ({
  display: 'flex',
  padding: 15,
  flexWrap: 'wrap',
  [theme.breakpoints.down('xs')]: {
    padding: 15,
  },
  gap: 30,
}));

export const ProfileItemCont = styled('div')(({ theme }) => ({
  display: 'flex',
  padding: 10,
  borderRadius: 10,
  cursor: 'pointer',
  backgroundColor: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_FLOATING : LIGHT_CONTAINER_FIELDS_FLOATING,
  width: 350,
  height: 140,
  alignContent: 'center',
  transition: '300ms',
  '&:hover': {
    background: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_ON_CARD : LIGHT_CONTAINER_FIELDS_ON_CARD,
  },
  margin: '0 0 10px 0',
  [theme.breakpoints.down('xs')]: {
    width: '100%',
  },
  position: 'relative',
}));

export const Avatar = styled('img')({
  maxWidth: 70,
  maxHeight: 90,
  minWidth: 70,
  minHeight: 90,
  alignSelf: 'center',
  objectFit: 'cover',
  borderImageSlice: '1',
  backgroundOrigin: 'border-box',
  backgroundClip: 'content-box, border-box',
  borderRadius: '10px !important',
});

export const ItemInfo = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  padding: '0px 8px',
  justifyContent: 'center',
  margin: 10,
  overflow: 'hidden',
  flex: 1,
});

export const ItemName = styled('span')(({ theme }) => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
  fontSize: 16,
}));

export const ItemAgency = styled('span')({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontSize: 14,
  color: PRIMARY_TEXT,
});

export const ItemDivision = styled('span')(({ theme }) => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontSize: 13,
  color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
  fontWeight: 600,
}));

export const ItemContact = styled('span')(({ theme }) => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontSize: 12,
  color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
}));

export const PrivateCD = styled('span')({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontSize: 14,
  fontWeight: 500,
  color: WARNING_TEXT,
});

export const ItemCompletion = styled('div')({
  overflow: 'hidden',
  color: 'white',
  display: 'flex',
  minWidth: 40,
  minHeight: 50,
  maxWidth: 40,
});

export const AddCont = styled('div')({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
});

export const AddModalCont = styled('div')<Theme, { width: number }>(({ theme, width }) => ({
  width: 638,
  maxWidth: 638,
  height: 747,
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  padding: 30,

  '& .MuiSelect-iconOutlined': {
    right: '6px',
    top: '25px',
  },

  '& .MuiSelect-iconOpen': {
    top: '5px',
    right: '20px',
  },

  '& .MuiAutocomplete-popupIndicator .MuiSvgIcon-root': {
    transform: 'translate(5px, 9px)',
  },
  '& .MuiAutocomplete-popper': {
    backgroundColor: 'red',
  },

  [theme.breakpoints.down('md')]: {
    width: '100%',
    padding: 20,
  },
}));

export const AddModalLabel = styled('span')(({ theme }) => ({
  width: '100%',
  color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
  fontSize: 13,
}));

export const ModalButton = styled(Button)({
  height: '50px !important',
  borderRadius: 8,
  textTransform: 'unset',
  textDecoration: 'none!important',
});

export const AgencyInput = styled(TextField)({
  marginTop: 15,
});

export const Warning = styled('span')({
  color: WARNING_TEXT,
  width: '100%',
  marginTop: 5,
  fontSize: 13,
});

export const MakePrimaryButton = styled(Button)(({ theme, isPrimary, loading }: any) => ({
  position: 'absolute',
  top: -23,
  padding: '0 10px',
  '&:hover': {
    backgroundColor: `${DARK_FIELDS_FLOATING_BUTTON_BACKGROUND} !important`,
    color: theme.palette.type === 'dark' ? '' : PLAIN_TEXT,
  },
  borderRadius: '6px 6px 0 0',
  textTransform: 'uppercase',
  width: 125,
  background:
    isPrimary && !loading
      ? PRIMARY_BUTTON_BACKGROUND
      : theme.palette.type === 'dark'
        ? DARK_BUTTON_BORDER
        : LIGHT_BUTTON_BORDER,
  color: isPrimary && !loading ? PLAIN_TEXT : theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
}));

export const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      backgroundColor:
        (theme.palette.type === 'dark' ? DARK_FIELDS_ON_CARD_MENU : LIGHT_MENUITEM_BACKGROUND) + ' !important',
      '& .MuiSelect-icon': {
        color: (theme.palette.type === 'dark' ? PLAIN_ICON : DARK_ICON) + '!important', // Change this to your desired color,
        top: 15,
        right: 12,
      },
    },
  }),
);
